/** Incoming query param (`?excludeTouExperiment=true`). Stored on the flow as `showPromotionDialog`. */
export const excludeTouExperimentQueryParam = 'excludeTouExperiment';
